import React, { useContext, useEffect } from 'react'
/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { ProviderIncomeDashboard } from '../IncomeDashboard';
import { useMediaQuery } from '@mui/material';


/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end


const PieDonutChart = ({ data, year }) => {

  const {
    arrMuseum,
    option,
  } = useContext(ProviderIncomeDashboard);
  const matchesUp768 = useMediaQuery('(min-width:768px)');

  useEffect(() => {
    // Create chart instance
    let chart = null;
    let hasValue = data.findIndex(f => f.value !== 0) !== -1;
    if (hasValue) {
      chart = am4core.create("chart-donut-" + year, am4charts.PieChart3D);
      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

      let title = chart.titles.create();
      title.text = "รายได้ตามแผน";
      title.fontSize = 16;
      title.align = "center";
      title.fontWeight = '400';
      title.marginBottom = -30;

      chart.data = data;

      chart.innerRadius = 60;
      chart.radius = am4core.percent(matchesUp768 ?  70 : 50);

      let series = chart.series.push(new am4charts.PieSeries3D());
      series.dataFields.hiddenInLegend = "disabled";
      // label
      series.dataFields.value = "value";
      series.dataFields.category = "label";
      series.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
      series.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
      series.labels.template.fontSize = 10;
      series.tooltip.label.wrap = true;
      series.tooltip.label.width = 300;
      series.labels.template.maxWidth = matchesUp768 ? 155 : 70;
      series.labels.template.wrap = true;
      series.slices.template.propertyFields.fill = "sColor";

      series.hiddenState.properties.opacity = 1;
      series.hiddenState.properties.endAngle = -90;
      series.hiddenState.properties.startAngle = -90;

    }
    else {
      chart = am4core.create("chart-donut-" + year, am4charts.PieChart);
      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in


      let title = chart.titles.create();
      title.text = "รายได้ตามแผน";
      title.fontSize = 16;
      title.align = "center";
      title.fontWeight = '400';
      title.marginBottom = -30;

      let lsEmpty = [{
        "sField": "Dummy",
        "disabled": true,
        "sValue": 1000,
        "color": am4core.color("#dadada"),
        "opacity": 0.3,
        "strokeDasharray": "4,4",
        "tooltip": ""
      }];

      let lstMeseumSelect = option.lstMuseum.filter(f => arrMuseum.includes(f.value));
      if (lstMeseumSelect.length !== 0) {
        lstMeseumSelect.forEach(element => {
          lsEmpty.push({
            "sField": element.label,
            "disabled": false,
            "sValue": 0,
            "color": am4core.color("#dadada"),
            "opacity": 0.3,
            "strokeDasharray": "4,4",
            "tooltip": element.label,
          })
        });
      }
      chart.data = lsEmpty;
      chart.radius = am4core.percent(matchesUp768 ? 60 : 50);
      chart.innerRadius = am4core.percent(30)

      let series = chart.series.push(new am4charts.PieSeries());
      series.dataFields.value = "sValue";
      series.dataFields.category = "sField";
      series.dataFields.hiddenInLegend = "disabled";
      series.labels.template.fontSize = 10;
      series.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
      series.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
      series.tooltip.label.wrap = true;
      series.tooltip.label.width = 300;
      series.labels.template.maxWidth = matchesUp768 ? 180 : 140;
      series.labels.template.wrap = true;


      /* Set tup slice appearance */
      let slice = series.slices.template;
      slice.propertyFields.fill = "color";
      slice.propertyFields.fillOpacity = "opacity";
      slice.propertyFields.stroke = "color";
      slice.propertyFields.strokeDasharray = "strokeDasharray";
      slice.propertyFields.tooltipText = "tooltip";

      series.labels.template.propertyFields.disabled = "disabled";
      series.ticks.template.propertyFields.disabled = "disabled";

      /* This creates initial animation */
      series.hiddenState.properties.opacity = 1;
      series.hiddenState.properties.endAngle = -90;
      series.hiddenState.properties.startAngle = -90;
    }



    // Cleanup on component unmount
    return () => {
      chart.dispose();
    };
  }, [arrMuseum, data, option.lstMuseum, year])


  return (
    <div id={"chart-donut-" + year} style={{ width: "100%", height: "400px" }}></div>
  )
}

export default PieDonutChart